import { CalculateForUnknownAir } from "./calculate-for-unknown-air";
import { CalculateForUnknownSea } from "./calculate-for-unknown-sea";
import type { ShipProcessingFee } from "@/schemas/ship";

type UnknownFreightMethod = "Air" | "Sea";

const inputClassName =
  "h-[68px] w-full rounded-full border-none bg-white px-6 text-base text-primary-900 shadow-[0px_1.72px_3.45px_0px_rgba(16,24,40,0.05)] outline-none placeholder:text-primary-text-200";

function CalculateForUnknown({
  freightMethod,
  processingFees,
}: {
  freightMethod: UnknownFreightMethod;
  processingFees: ShipProcessingFee[];
}) {
  return freightMethod === "Air" ? (
    <CalculateForUnknownAir inputClassName={inputClassName} processingFees={processingFees} />
  ) : (
    <CalculateForUnknownSea inputClassName={inputClassName} processingFees={processingFees} />
  );
}

export default CalculateForUnknown;

